import { render, staticRenderFns } from "./printView.vue?vue&type=template&id=f38cf41a&scoped=true&"
import script from "./printView.vue?vue&type=script&lang=js&"
export * from "./printView.vue?vue&type=script&lang=js&"
import style0 from "./printView.vue?vue&type=style&index=0&id=f38cf41a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38cf41a",
  null
  
)

export default component.exports